import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { registration } from '../../../types/registrations.type';
import { sfcApi } from '../../api';
export interface RegistrationCreateUpdateValues {
  id?: number;
  course_id?: number;
}
export const registrationApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegistrations: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `registrations${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['Registrations']
    }),
    getRegistration: builder.query<{ registration: registration }, number>({
      query: (id) => `registrations/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Registrations', id }]
    }),

    createRegistration: builder.mutation<
      { registration: registration },
      RegistrationCreateUpdateValues
    >({
      query: (data) => {
        return {
          url: 'registrations/create',
          method: 'POST',
          body: {
            ...data
          }
        };
      },
      invalidatesTags: ['Registrations']
    }),
    batchRefundRegistration: builder.mutation<{ refund: any }, RegistrationCreateUpdateValues>({
      query: (data) => {
        return {
          url: 'registrations/refund',
          method: 'PUT',
          body: {
            ...data
          }
        };
      },
      invalidatesTags: ['Registrations']
    }),
    updateRegistration: builder.mutation<
      { registration: registration },
      RegistrationCreateUpdateValues
    >({
      query: (data) => {
        const { id, ...requestObject } = data;
        return {
          url: `registrations/${id}/transfer`,
          method: 'PUT',
          body: {
            ...requestObject
          }
        };
      },
      invalidatesTags: (result, _error, { id }) => [
        { type: 'Registrations', id: result?.registration?.id ?? id },
        'Registrations'
      ]
    }),

    deleteRegistration: builder.mutation<{ registration: registration }, number>({
      query: (id) => ({
        url: `registrations/${id}/deactivate`,
        method: 'PUT'
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'Registrations', id },
        'Registrations'
      ]
    }),
    destroyRegistration: builder.mutation<{ registration: registration }, number>({
      query: (id) => ({
        url: `registrations/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'Registrations', id },
        'Registrations',
        'Order'
      ]
    }),
    activateRegistration: builder.mutation<{ registration: registration }, number>({
      query: (id) => ({
        url: `registrations/${id}/activate`,
        method: 'PUT'
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'Registrations', id },
        'Registrations'
      ]
    })
  })
});

export const {
  useGetRegistrationsQuery,
  useGetRegistrationQuery,
  useCreateRegistrationMutation,
  useUpdateRegistrationMutation,
  useDeleteRegistrationMutation,
  useDestroyRegistrationMutation,
  useActivateRegistrationMutation,
  useBatchRefundRegistrationMutation
} = registrationApi;
